import React from 'react';
import './FloatingBubbles.css';

/**
 * FloatingBubbles — Ambient Glass Bubbles for Main Layout
 * Renders 5 subtle, small, floating glass bubbles in Seikural brand colors.
 */
const FloatingBubbles = () => {
  return (
    <div className="sipl-bubbles-canvas" aria-hidden="true">
      <div className="sipl-glass-bubble bubble-teal" />
      <div className="sipl-glass-bubble bubble-orange" />
      <div className="sipl-glass-bubble bubble-green" />
      <div className="sipl-glass-bubble bubble-blue" />
      <div className="sipl-glass-bubble bubble-cyan" />
    </div>
  );
};

export default React.memo(FloatingBubbles);
